import {
    Accordion,
    AppShell,
    Box,
    Burger,
    Button, Card,
    Collapse,
    Flex, List, LoadingOverlay,
    Menu,
    Select, Space,
    Switch, Text,
    TextInput,
    UnstyledButton
} from "@mantine/core";
import ExportDrawer from "./components/ExportDrawer";
import classes from "./css/Results.module.css";
import {
    IconAntennaBars3,
    IconAntennaBars5, IconBallpenOff,
    IconChevronDown,
    IconCircleNumber1,
    IconDashboard, IconFlagFilled,
    IconInfoCircle,
    IconRefresh,
    IconSearch
} from "@tabler/icons-react";
import React, {useState} from "react";
import {useDisclosure} from "@mantine/hooks";
import {setCustomer, setHighlighted} from "./redux/actions";
import {useDispatch, useSelector} from "react-redux";
import {useForm} from "@mantine/form";
import {useTranslation} from "react-i18next";
import LanguageSelect from "./components/LanguageSelect";
import NonGridHighlightButton from "./components/NonGridHighlightButton"

export default function MobileResults({refreshPage, logout, customers,
                                          isMultiCustomer, loading, toggleRefresh, loadMore, lastActivationDate, rowCount, endpoints,
                                      isLoading, navigate, openError, search, setSearch, formatToBeaconDate}) {
    const [openedMobileBurger, { toggle }] = useDisclosure(false)
    const [openedExportDrawer, { open: openDrawer, close: closeDrawer }] = useDisclosure(false);
    const { t} = useTranslation();
    const submit = (e) => {

        if(search === ""){
            return
        }
        const searchWithNoWhiteSpace = search.replace(/\s/g, ''); //replace whitespace
        fetch(`/api/v1/Activation/${searchWithNoWhiteSpace}`,{
            method:"GET",
            credentials: 'include',
        }).then(response=> response.json())
            .then(result =>{
                if(result){
                    navigate(`/${searchWithNoWhiteSpace}`)
                }else {
                    openError()
                }
            }).catch((error)=>{
            console.log(error)
            //alert("Network Error, please try again!")
        })
    }
    const currentCustomer = useSelector(state => state.customer.currentCustomer);
    const dispatch = useDispatch();
    const handleSetCustomer = (newCustomer) => {
        //localStorage.setItem("currentCustomer", newCustomer);
        dispatch(setCustomer(newCustomer))
    }
    // const [loading, setLoadingRefresh] = useState(false)
    const form = useForm({
        initialValues: {
            search: ""
        }})

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            submit()
        }
    };

    const endpointStatusRenderer = (params) => {
        return(<span> {params === "Good" ? <IconFlagFilled className={classes.tablerIconGreen}/> : <IconFlagFilled className={classes.tablerIconRed}/>} </span>)
    }

    const meterStatusRenderer = (params) => {
        return(<span> {params === "Good" ? <IconDashboard className={classes.tablerIconGreen}/> : <IconDashboard className={classes.tablerIconRed}/>} </span>)
    }

    const signalStrengthRenderer = (params) => {
        return (<span> {params === "N/A" || params == null ? "N/A" : (params === "Good" ? <IconAntennaBars5 className={classes.tablerIconGreen}/> : <IconAntennaBars3 className={classes.tablerIconRed}/>)} </span>)
    }

    const highlightedList = useSelector(state => state.customer.highlightedList)

    const mobileEndpoints = endpoints.map((endpoint) => (
        <Accordion.Item key={endpoint.SerialNumber} value={endpoint.SerialNumber}>
            <Accordion.Control style={{
                backgroundColor: highlightedList.includes(endpoint.SerialNumber) ? '#fafa66' : 'white',
            }}><Flex gap="xs" justify="space-between"><Box style={{minWidth: "25%", marginTop: 15, marginBottom: 5}}>{endpoint.SerialNumber}</Box><Box style={{marginRight: 5}}>{signalStrengthRenderer(endpoint.NetworkStatus)}
                {endpointStatusRenderer(endpoint.EndpointStatus)}{meterStatusRenderer(endpoint.MeterStatus)}</Box></Flex></Accordion.Control>
            <Accordion.Panel>
                <List
                    spacing="xs"
                    size="sm"
                >
                    <List.Item><b>{t("Encoder SN")}:</b> {endpoint.EncoderSerialNumber}</List.Item>
                    <List.Item><b>{t("Customer Name")}:</b> {endpoint.Customer}</List.Item>
                    <List.Item><b>{t("Activation Time")}:</b> {formatToBeaconDate(endpoint.ActivationTime)}</List.Item>
                    <List.Item><b>{t("Last Communication Time")}:</b> {formatToBeaconDate(endpoint.LastCommunicationTime)}</List.Item>
                    <List.Item><b>{t("Signal Strength")}:</b> {signalStrengthRenderer(endpoint.NetworkStatus)}</List.Item>
                    <List.Item><b>{t("Endpoint Status")}:</b> {t(endpoint.EndpointStatus)}</List.Item>
                    <List.Item><b>{t("Meter Status")}:</b> {t(endpoint.MeterStatus)}</List.Item>
                    <List.Item><b>{t("Last Register Read")}:</b> {endpoint.LastRead}</List.Item>
                </List>
                <Flex justify={"flex-end"}>
                <NonGridHighlightButton SN={endpoint.SerialNumber}/>
                </Flex>
            </Accordion.Panel>
        </Accordion.Item>
    ));
    const clear = () => {
        localStorage.setItem('highlightedList', JSON.stringify([]))
        dispatch(setHighlighted([]))
    }

    return (<div>
        <AppShell padding="xl">
            <ExportDrawer isMobile={true} closeDrawer={closeDrawer} isOpen={openedExportDrawer}/>
            <AppShell.Header>
                <Flex
                    id="bar"
                    mih={50}
                    bg="#147DC2"
                    gap="xl"
                    justify="flex-end"
                    align="flex-start"
                    direction="row"
                    wrap="nowrap"
                    p="xs"
                    sx={(theme) => ({
                        boxShadow: theme.shadows.lg, // Add shadow here
                    })}
                >
                    <UnstyledButton size="xl" pt="xs" ff="heading" flex="auto" fw={700}
                                    c="white" onClick={refreshPage}>
                        ORION® Status Checker
                    </UnstyledButton>
                    <Burger opened={openedMobileBurger} onClick={toggle} color="white"/>
                </Flex>
                <Collapse in={openedMobileBurger}>
                    <Flex
                        bg="#147DC2"
                        gap="sm"
                        direction="column"
                        p="xs"
                        sx={(theme) => ({
                            boxShadow: theme.shadows.lg, // Add shadow here
                        })}
                    >
                        <LanguageSelect isMobile={true}/>
                        <Button color="red" disabled={highlightedList.length === 0} onClick={clear} leftSection={<IconBallpenOff/>}>
                            <Text fw={500}>{t('Clear All Highlights')}</Text>
                        </Button>
                        <Button size="md" onClick={openDrawer}
                                name="btn" id="btn">{t("Export")}</Button>
                        <Button size="md" onClick={logout} name="btn"
                                id="btn">{t("Logout")}</Button>
                        <Flex justify="center">
                            <Switch className={classes.autoRefreshSwitch} size="lg" checked={loading}
                                    onChange={toggleRefresh} fw={600} labelPosition="left" label="Auto-Refresh"
                                    c="white"/>
                            &ensp;{loading ? (<IconRefresh className={classes.rotating}/>) : (
                            <IconRefresh className={classes.refresh}/>)}
                        </Flex>
                    </Flex>
                </Collapse>
            </AppShell.Header>
            <AppShell.Main>
                <div style={{paddingTop: "10%"}}>
                    <Flex
                        direction="column"
                        gap="sm"
                        pb="xl"
                    >
                        {isMultiCustomer ? (<Select
                            label={t("Customer Name")}
                            data={customers}
                            value={currentCustomer}
                            onChange={handleSetCustomer}
                            rightSection={<IconChevronDown/>}
                            allowDeselect={false}
                            size="md"
                            comboboxProps={{shadow: 'md'}}
                            styles={{input: {textOverflow: 'ellipsis'}}}
                            //makes it in-line with search bar
                        />) : (<div><Select
                            className={classes.noClick}
                            size="md"
                            label={t("Customer Name")}
                            data={customers}
                            value={currentCustomer}
                            rightSection={<IconCircleNumber1 color="white"/>}
                            styles={{input: {textOverflow: 'ellipsis'}}}
                        /></div>)}
                        <form action="." onSubmit={form.onSubmit(() => {
                            submit()
                        })}>
                            <TextInput
                                size="md"
                                radius="sm"
                                type="search"
                                value={search}
                                placeholder={t("Endpoint SN")}
                                onChange={(e) => setSearch(e.target.value)}
                                name="text"
                                id="text"
                                onKeyUp={handleKeyPress}
                                leftSection={<IconSearch/>}
                            />
                        </form>
                    </Flex>
                    <Flex justify="space-between">
                        <Box><strong style={{marginLeft: 15, minWidth: "25%"}}>{t("Endpoint SN")}</strong></Box>
                        <Box style={{marginLeft: 50, marginRight: 40}}><strong>{t("Other Info")}</strong>
                            <Menu shadow="md" withArrow position="top">
                                <Menu.Target>
                                    <UnstyledButton style={{marginLeft: 5}}><IconInfoCircle color="#117CC1" size="18"/></UnstyledButton>
                                </Menu.Target>

                                <Menu.Dropdown>
                                    <Menu.Label>{t("Key")}</Menu.Label>
                                    <Menu.Item rightSection={<IconDashboard/>}>
                                        {t("Meter Status")}
                                    </Menu.Item>
                                    <Menu.Item rightSection={<IconFlagFilled/>}>
                                        {t("Endpoint Status")}
                                    </Menu.Item>
                                    <Menu.Item rightSection={<IconAntennaBars5/>}>
                                        {t("Signal Strength")}
                                    </Menu.Item>
                                </Menu.Dropdown>
                            </Menu>
                        </Box>
                    </Flex>


                    <Card padding="xs">

                        {endpoints.length === 0 ? (<div><LoadingOverlay visible={isLoading} zIndex={10}
                                                                        overlayProps={{radius: "sm", blur: 8}}/>
                                <Accordion><Space h="xl"/></Accordion></div>
                        ) : (<div><LoadingOverlay visible={isLoading} zIndex={10}
                                                  overlayProps={{radius: "sm", blur: 8}}/>
                            <Accordion classNames={classes}>
                                {mobileEndpoints}
                            </Accordion></div>)}
                    </Card>
                    <Space h="sm"/>
                    <Flex direction="column" align="center">
                        <Button fullWidth={true} disabled={!lastActivationDate} onClick={loadMore}>{t("Load More")}</Button>
                        <Space h={"sm"}/>
                        <Button className={classes.noClick} variant="light">
                            <Text fw={500}>{t('displaying-results', { n: rowCount })}</Text>
                        </Button>
                        <Space h={"sm"}/>

                    </Flex>
                </div>
            </AppShell.Main>
        </AppShell>
    </div>)
}